"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AbstractHandler = void 0;
var msrc_messenger_1 = require("@migros/msrc-messenger");
var config_1 = require("../config");
var AbstractHandler = /** @class */ (function () {
    function AbstractHandler(config) {
        this.config = config;
    }
    AbstractHandler.prototype.checkIsManualLoginUsingCookie = function () {
        var manualLoginTime = localStorage.getItem(config_1.MANUAL_LOGIN_TIMESTAMP_COOKIE);
        var isManualLogin = !!manualLoginTime && parseInt(manualLoginTime, 10) > Date.now() - config_1.MANUAL_LOGIN_TIMEOUT;
        if (isManualLogin) {
            localStorage.removeItem(config_1.MANUAL_LOGIN_TIMESTAMP_COOKIE);
        }
        return isManualLogin;
    };
    AbstractHandler.prototype.publishAuthenticate = function (_a) {
        var loggedIn = _a.loggedIn, isManualLogin = _a.isManualLogin, error = _a.error;
        msrc_messenger_1.messenger.publish(msrc_messenger_1.MessageTypes.LoginAuthenticate, {
            loggedIn: loggedIn,
            isManualLogin: isManualLogin,
            error: error !== null && error !== void 0 ? error : null,
        });
    };
    AbstractHandler.prototype.publishTokenRenew = function (token) {
        msrc_messenger_1.messenger.publish(msrc_messenger_1.MessageTypes.LoginTokenRenew, { token: token });
    };
    return AbstractHandler;
}());
exports.AbstractHandler = AbstractHandler;
